import { createFileRoute } from '@tanstack/react-router'
import { requireRoles } from '@/lib/middleware'
import { MyConsent } from '@/features/participant/consent'

export const Route = createFileRoute(
  '/_authenticated/_organization/my-consent/'
)({
  beforeLoad: async () => requireRoles(['client', 'primary_contact', 'supported_employee']),
  component: MyConsent,
})
